import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import {
  permissaoBehavior,
  PermissaoEnum,
  RoleEnum,
} from '../../models/role.enum';
import { UserService } from '../services/user/user.service';
import { Subscription } from 'rxjs';
import { StorageServiceService } from '../storage/storage-service.service';

@Directive({
  selector: '[roles]',
  standalone: true,
})
export class RolesDirective implements OnInit, OnDestroy {
  @Input('roles') roles: string[] = [];
  private subscription: Subscription | undefined;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private readonly userService: UserService,
    private readonly storageService: StorageServiceService,
  ) {}

  ngOnInit(): void {
    this.roles = this.roles.map((role) => 'ROLE_' + role);

    this.subscription = this.userService.permissao.subscribe((permissao) => {
      this.viewContainer.clear();

      // Se não tiver permissao vinda do BehaviorSubject, tenta pegar do storage
      const permissaoValida = permissao ?? this.storageService.obterPermissao();

      if (!permissaoValida) {
        return; // Nem no storage encontrou, sai fora
      }

      const role = PermissaoEnum[permissaoValida.id as number];

      if (role && this.roles.includes(role)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
